
export enum BillToRelationCd {
	NOT_APPLICABLE = 'NotApplicable',
	RELATED_TO_BOTH = 'RelatedToBoth',
	RELATED_TO_CONS = 'RelatedToCons',
	RELATED_TO_SHPR = 'RelatedToShpr',
	UNRELATED = 'Unrelated'}

